// Copyright 2025-2026 - Hewlett Packard Enterprise Company

import { useContext } from 'react';
import { Box } from 'grommet';

import { SidebarContext } from '../../providers/SidebarProvider';
import Help from '../Help/Help';

export default function SidebarContent({ width, ...rest }) {
  const { isChatOpen, isInsightsOpen, setAuthenticatedPortalNode } =
    useContext(SidebarContext);

  return (
    <Box border="left" width={width} fill overflow="auto" {...rest}>
      {(isChatOpen || isInsightsOpen) && (
        <Box ref={setAuthenticatedPortalNode} fill />
      )}
      <Help width={width} />
    </Box>
  );
}
